import { UrlMatcher, UrlSegment } from "@angular/router";

/**
 * @description 
 *  - Custom URL matcher to identify and redirect old 'fsqs' routes to new 'food-safety-iq' routes.
 *  - This matcher checks if the first segment of the URL is 'fsqs'.
 *  - If a match is found, it triggers the FsqsRedirectGuard to handle the redirection.
 *
 * @param url
 *  - The array of URL segments to be matched.
 * @returns 
 *  - An object with the consumed URL segments if a match is found, otherwise undefined.
 */

export const fsqsRedirectMatcher: UrlMatcher = (segments: UrlSegment[]) => {
    if (segments.length && segments[0].path === 'fsqs') {
        return { consumed: segments };
    }
    return null;
};